// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","85":"exceljs","367":"confetti","969":"sweetalert2"}[chunkId] || chunkId) + "." + {"53":"de6e12eb","85":"ca3cbfc5","125":"fcb9e4d1","234":"88536ffb","353":"bb9c6104","367":"f19d92e2","892":"434ab03c","969":"34ff9bc8"}[chunkId] + ".js";
};